import { render, staticRenderFns } from "./user_profile_certificates.vue?vue&type=template&id=6c2b19bc&scoped=true"
import script from "./user_profile_certificates.vue?vue&type=script&lang=js"
export * from "./user_profile_certificates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2b19bc",
  null
  
)

export default component.exports